function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3906 11.4316C22.3498 11.3063 22.2704 11.197 22.1638 11.1195C22.0572 11.0419 21.9287 11.0001 21.7969 11H20.375V8.8125C20.375 8.4668 20.0957 8.1875 19.75 8.1875H12.25C11.9043 8.1875 11.625 8.4668 11.625 8.8125V11H10.2031C10.0712 10.9998 9.94264 11.0415 9.83593 11.1191C9.72923 11.1967 9.6499 11.3061 9.60938 11.4316L8.1875 15.8047V23.1875C8.1875 23.5332 8.4668 23.8125 8.8125 23.8125H23.1875C23.5332 23.8125 23.8125 23.5332 23.8125 23.1875V15.8047L22.3906 11.4316ZM13.0312 9.59375H18.9688V11H13.0312V9.59375ZM22.4062 22.4062H9.59375V16.0273L10.7715 12.4062H21.2285L22.4062 16.0273V22.4062ZM18.7344 17.1719H16.625V15.0625C16.625 14.9766 16.5547 14.9062 16.4688 14.9062H15.5312C15.4453 14.9062 15.375 14.9766 15.375 15.0625V17.1719H13.2656C13.1797 17.1719 13.1094 17.2422 13.1094 17.3281V18.2656C13.1094 18.3516 13.1797 18.4219 13.2656 18.4219H15.375V20.5312C15.375 20.6172 15.4453 20.6875 15.5312 20.6875H16.4688C16.5547 20.6875 16.625 20.6172 16.625 20.5312V18.4219H18.7344C18.8203 18.4219 18.8906 18.3516 18.8906 18.2656V17.3281C18.8906 17.2422 18.8203 17.1719 18.7344 17.1719Z",
  fill: "#404047"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 30.5,
  height: 30.5,
  rx: 15.25,
  stroke: "#404047",
  strokeWidth: 1.5
});

var SvgMedication = function SvgMedication(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedication, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medication.7899b7ce.svg";
export { ForwardRef as ReactComponent };